import graphqlClient from '@/graphql/graphql-client';
import { toPagingOnlyVariables } from '@/graphql/list-query';
import type { ListQueryVariables } from '@/graphql/types';
import { useQuery } from '@tanstack/react-query';

import {
  TaskManagerSectionsDocument,
  type TaskManagerSectionsQuery,
} from '@/graphql/generated/graphql';

export type TaskManagerSectionRecord = NonNullable<
  NonNullable<TaskManagerSectionsQuery['getTaskManagerSections']>['items']
>[number];
export type GetTaskManagerSectionsResponse = TaskManagerSectionsQuery;

export const useGetTaskManagerSections = (params?: ListQueryVariables<Record<string, unknown>>) => {
  const variables = toPagingOnlyVariables(params);
  return useQuery({
    queryKey: ['task-manager-sections', variables],
    queryFn: () => graphqlClient.request(TaskManagerSectionsDocument, variables),
  });
};

export const requestTaskManagerSections = (params?: ListQueryVariables<Record<string, unknown>>) => {
  const variables = toPagingOnlyVariables(params);
  return graphqlClient.request(TaskManagerSectionsDocument, variables);
};

export const GET_TASK_MANAGER_SECTIONS_QUERY = TaskManagerSectionsDocument;
